.createRoleWrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
}

/* 🔹 Top Header (optional if shared) */
.cardHeader {
    padding: 0.8rem 2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
        color: #000;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px;

    }
}

/* 🔹 MAIN 2-COLUMN LAYOUT */
.roleWrapper {
    display: grid;
    grid-template-columns: 1fr 1fr; // equal width
    gap: 0;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    overflow: hidden;
}

/* 🔹 LEFT SIDE - FORM */
.cardBody {
    display: flex;
    flex-direction: column;
    border-right: 1px solid #e5e7eb;
}

.formField {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 0.8rem 2rem;
}

.fieldLabel {
    font-size: 13px;
    font-weight: 500;
    color: #374151;
}

.fieldInput {
    height: 36px;
    background-color: #F9FAFB;
}
.textfeild{
    background-color: #F9FAFB;
}

/* 🔹 RIGHT SIDE - MODULES */
.assignModulesCard {

    display: flex;
    flex-direction: column;
}

/* Header with search */
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
}

.searchBox {
    display: flex;
    align-items: center;
    gap: 6px;
    border: 1px solid #e5e7eb;
    padding: 4px 8px;
    border-radius: 6px;
    background: transparent;
    height: 36px;
    margin-right: 8px;
    border: 1px solid #90A1B9;
}

.searchInput {
    border: none;
    outline: none;
    font-size: 13px;
    width: 140px;
    background: transparent !important;
}

/* 🔹 MODULE LIST */
.moduleList {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 8px;
    padding: 0.8rem 2rem;
}

.moduleItem {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
}

.checkbox,
input[type='checkbox'] {
    appearance: none;
    -webkit-appearance: none;
    width: 16px;
    height: 16px;
    border: 1px solid #155DFC;
    border-radius: 4px;
    background: #fff;
    cursor: pointer;
    position: relative;
}
 
.checkbox:checked,
input[type='checkbox']:checked {
    background-color: #155DFC;
    border-color: #155DFC;
}
.checkbox:checked::after,
input[type='checkbox']:checked::after {
    content: '';
    position: absolute;
    top: 1px;
    left: 5px;
    width: 4px;
    height: 8px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);

}
 

.selectAllLabel {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    font-size: 13px;
    font-weight: 500;
    margin-bottom: 8px;
    
    right: 30px;
}

.noModules {
    font-size: 13px;
    color: #9ca3af;
    text-align: center;
    padding: 4rem;
}

.selectedModulesPermissions {
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
}

.permissionsHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.8rem 2rem;
}

.permissionsTitle {
    margin: 0;
    color: #0f172a;
    font-size: 30px;
    font-style: normal;
    font-weight: 500;
    line-height: 40px;
}

.collapseAllBtn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #2563eb;
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
}

.permissionsHint {
    padding: 0.8rem 2rem;
    margin: 0;
    color: #64748b;
    font-size: 12px;
    line-height: 18px;
}

.permissionsModulesList {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 0.8rem 2rem 1.25rem;
}

.permissionsModule {
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background: #ffffff;
}

.permissionsModuleHeader {
    width: 100%;
    border: none;
    background: #f8fafc;
    padding: 10px 12px;
    border-radius: 8px 8px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}

.permissionsModuleLeft,
.permissionsFeatureLeft {
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.permissionsModuleName {
    font-size: 16px;
    font-weight: 500;
    color: #0f172a;
}

.permissionsChevron {
    color: #0f172a;
}

.permissionsModuleBody {
    padding: 10px 12px 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.permissionsFeature {
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background: #ffffff;
}

.permissionsFeatureHeader {
    width: 100%;
    border: none;
    background: #f8fafc;
    padding: 8px 10px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}

.permissionsFeatureName {
    font-size: 14px;
    font-weight: 500;
    color: #0f172a;
}

.permissionsFeatureBody {
    padding: 12px;
    border-top: 1px solid #e2e8f0;
}

.permissionsLabel {
    font-size: 14px;
    font-weight: 600;
    color: #111827;
    margin-bottom: 8px;
}

.permissionsGrid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px 18px;
}

.permissionItem {
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.permissionText {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.permissionName {
    font-size: 14px;
    color: #111827;
    line-height: 20px;
}

.permissionDesc {
    font-size: 12px;
    color: #64748b;
    line-height: 16px;
}